import styled from 'styled-components';
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { Variant } from '../../models/Product';
import { NavigationMenuItem } from '../../models/NavigationMenuItem';
import { CartProductVariant } from '../../models/Cart';

const QuantityContainer = styled('div')(({ theme }) => ({
    display: ' block',
    width: '100%',
    position: 'relative',
    marginRight: '15px',
}));

const ButtonContainer = styled('button')(({ theme }) => ({
    width: '30px',
    display: 'block',
    position: 'absolute',
    top: '0',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    height: '50px',
    '&.minus': {
        left: '0',
        right: 'auto',
    },
    '&.plus': {
        left: 'auto',
        right: '0',
    },
}));

const QuantityInput = styled('input')((theme) => ({
    width: '100%',
    padding: '10px 25px 9px 25px',
    textAlign: 'center',
    paddingTop: '10px',
    paddingBottom: '10px',
    minHeight: '50px',
    border: '1px solid #c7c7c7',
    borderRadius: '5px',
    appearance: 'none',
    '&:focus': {
        border: '1px solid #c7c7c7',
    },
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        appearance: 'none',
        margin: '0',
    },
}));

export const QuantitySelector: React.FC<QuantitySelectorProps> = (props) => {
    const { variant, qtyChanged, defaultQty } = props;
    const [qty, setQty] = useState(defaultQty ? defaultQty : 1);
    const increaseQty = () => {
        // if (
        //     (variant.currentlyNotInStock && variant.availableForSale) ||
        //     variant.quantityAvailable > qty
        // ) {
        setQty(qty + 1);
        qtyChanged(qty + 1);
        // }
    };

    const decreaseQty = () => {
        if (qty > 1) {
            setQty(qty - 1);
            qtyChanged(qty - 1);
        }
    };

    const handleChange = (event) => {
        setQty(event.target.value < 1 ? 1 : event.target.value);
        qtyChanged(event.target.value);
    };
    return (
        <QuantityContainer>
            <ButtonContainer className={'minus'} onClick={decreaseQty}>
                <RemoveIcon />
            </ButtonContainer>
            <QuantityInput
                min="1"
                value={qty}
                type={'number'}
                onChange={(e) => handleChange(e)}
            />
            <ButtonContainer className={'plus'} onClick={increaseQty}>
                <AddIcon />
            </ButtonContainer>
        </QuantityContainer>
    );
};

type QuantitySelectorProps = {
    variant: Variant | CartProductVariant;
    qtyChanged: (qty: number) => void;
    defaultQty?: number;
};
